import SwupProgressPlugin from "@swup/progress-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupDebugPlugin from "@swup/debug-plugin";
import {animateScrollTo} from "@/modules/utils";
import Swup from "swup";

let controller = new AbortController();

const initPreloader = () => {
    const preloader = document.getElementById('ftco-loader')
    if (preloader) setTimeout(() => {
        preloader.classList.remove('show');
        setTimeout(() => preloader.remove(), 300);
    }, 500);
}

const registerGlobalHandlers = () => {
    $("[data-view]").each(function () {
        const __THIS = $(this);
        $("body").addClass(`${__THIS.attr("data-view")}-view`);
    });

    document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const element = document.querySelector<HTMLElement>(el.getAttribute('data-scroll-to'));
            if (!element) return;

            let substract = el.getAttribute('data-offset') || '80'
            let timeout = el.getAttribute('data-timeout') || '1000'

            animateScrollTo(element, parseInt(substract), parseInt(timeout))
            toggleMobileMenu('off');
            return false;
        })
    })

    document.querySelectorAll('.custom__scrollbar.dismissible').forEach((el) => {
        el.addEventListener('mouseenter', () => {
            el.classList.add('hovered');
        })

        el.addEventListener('mouseleave', () => {
            el.classList.remove('hovered');
        })
    });
}

export const toggleMobileMenu = (render: 'off' | 'on' | 'auto') => {
    const root = document.querySelector('html');
    if (render === 'on') {
        if (window.AppScroll) window.AppScroll.stop();
        root.classList.add('mobile-menu:true')
    } else if (render === 'off') {
        root.classList.remove('mobile-menu:true')
        if (window.AppScroll) window.AppScroll.start();
    } else toggleMobileMenu(root.classList.contains('mobile-menu:true') ? 'off' : 'on')
}

const initMobileMenu = () => {
    controller?.abort();
    controller = new AbortController();
    const {signal} = controller

    const container = document.querySelector<HTMLElement>('#mobile__menu');

    document.querySelectorAll('[data-menu="mobile"]').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            toggleMobileMenu('auto');
            return false;
        }, {signal})
    })

    if (container) container.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        // console.log(target, target.closest('.menu__content'))
        // return ;
        if (!target.closest('.menu__content')) {
            e.preventDefault();
            toggleMobileMenu('off')
            return false;
        }
    }, {signal})
}

const initDesktopMenu = () => {
    const header = document.getElementById('header__upgrade');
    const wa = document.querySelector('[data-widget="whatsapp"]');

    const doThis = () => {
        if (header) header.classList.toggle('scrolled', window.scrollY > 70);
        if (wa) wa.classList.toggle('render', window.scrollY > 200);
    }

    doThis();
    window.addEventListener('scroll', () => doThis())
}

const registerMenuHandlers = () => {
    initMobileMenu();
    initDesktopMenu();
}

const removeListeners = () => {
    const currentView = $("[data-view]").attr("data-view") || "";
    $('html, body').removeClass('overflow-hidden');
    $('body').removeClass(`${currentView}-view`);
    toggleMobileMenu('off');
};


interface InitSwupParams {
    containers: string[],
    onContentReplace: () => void,
    onContentLoaded: () => void,
    onAnimationEnd?: () => void,
    animationPlugin?: any,
    debug: boolean
}

const initSwupJs = ({containers, onContentReplace, onContentLoaded, onAnimationEnd, animationPlugin, debug = false}: InitSwupParams) => {
    const ttl = 60_000; // 1 minutes

    const progressPlugin = new SwupProgressPlugin({
        delay: 300,
        transition: 300,
        initialValue: 0.25,
        // hideImmediately: true,
        className: "swup-progress-bar",
    });

    const preloadPlugin = new SwupPreloadPlugin({
        throttle: 5,
        preloadHoveredLinks: true,
        preloadVisibleLinks: true,
    });

    const instance: Swup = new Swup({
        containers: containers,
        cache: true,
        native: false,//Note: if pages can load quickly set to true
        ignoreVisit: (_, {el} = {}) => Boolean(el?.closest('[data-no-swup]')) || Boolean(el?.closest('[href="#"]'))
    });

    instance.use(progressPlugin);
    instance.use(preloadPlugin);

    if (animationPlugin) instance.use(animationPlugin);
    if (debug) instance.use(new SwupDebugPlugin({globalInstance: true}))

    instance.hooks.on('page:view', (visit) => {
        window['__viewStory'].previous = visit.from.url;
        window['__viewStory'].current = visit.to.url;
        onContentLoaded();
    });

    if (onAnimationEnd) instance.hooks.on("animation:in:end", onAnimationEnd);
    instance.hooks.before("content:replace", onContentReplace);

    // When a page is cached, append the current timestamp and time-to-live
    instance.hooks.on('cache:set', (_, {page}) => {
        instance.cache.update(page.url, {created: Date.now(), ttl});
    });

    // Before each request, remove all invalid entries by timestamp
    instance.hooks.before('page:load', () => {
        // noinspection JSCheckFunctionSignatures
        instance.cache.prune((_, {created, ttl}: any) => Date.now() > created + ttl);
    });

    return instance;
};

export const Designer = {
    initPreloader,
    removeListeners,
    initViewManager: initSwupJs,

    init: () => {
        registerGlobalHandlers();
        registerMenuHandlers();
    }
}

export default Designer;